var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiLangSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0875 16.8375L11.9125 13.7L11.95 13.6625C14.125 11.2375 15.675 8.45 16.5875 5.5H20.25V3H11.5V0.5H9V3H0.25V5.4875H14.2125C13.375 7.9 12.05 10.1875 10.25 12.1875C9.0875 10.9 8.125 9.4875 7.3625 8H4.8625C5.775 10.0375 7.025 11.9625 8.5875 13.7L2.225 19.975L4 21.75L10.25 15.5L14.1375 19.3875L15.0875 16.8375ZM22.125 10.5H19.625L14 25.5H16.5L17.9 21.75H23.8375L25.25 25.5H27.75L22.125 10.5ZM18.85 19.25L20.875 13.8375L22.9 19.25H18.85Z",
    fill: "url(#paint0_linear_2721_2027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2721_2027",
    x1: 0.25,
    y1: 0.5,
    x2: 30.7232,
    y2: 4.89763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA0C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLangSearch);
export default __webpack_public_path__ + "static/media/multiLangSearch.0aa2d12b338958d41c8c1606dd910edd.svg";
export { ForwardRef as ReactComponent };